module.exports = __webpack_public_path__ + "static/media/outline-cactus.829be644.svg";